<template>
  <label class="gp-checkbox-wrap" :class="[`size-${size}`]" :size="size">

    <svg v-if="!isChecked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="8.125" stroke="#9E9E9E" stroke-width="1.25"/>
    </svg>
    
    <svg v-if="isChecked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="8.125" stroke="#3C67FF" stroke-width="1.25"/>
      <circle cx="9.99978" cy="10" r="4.86111" fill="#3C67FF"/>
    </svg>

    <input class="checkbox" type="radio" :checked="isChecked" :value="value" @change="updateInput"/>
    <span class="gp-checkbox-text">{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: "GpCheckbox",
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    value: {type: String},
    modelValue: {default: ""},
    label: {type: String, required: true},
    trueValue: {default: true},
    falseValue: {default: false},
    size: {default: "medium"}
  },
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value);
      }
      // Note that `true-value` and `false-value` are camelCase in the JS
      return this.modelValue === this.trueValue;
    }
  },
  methods: {
    updateInput(event) {
      const isChecked = event.target.checked;
      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue];
        if (isChecked) {
          newValue = [this.value];
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }
        this.$emit("change", newValue);
      } else {
        const valueEmit = isChecked ? true : false;
        this.$emit("change", valueEmit);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
/* Customize the label (the wrapper) */
.gp-checkbox-wrap {
  display: flex;
  position: relative;
  margin-bottom: 6px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
  margin: 0;

  &.size-medium {
    .checkmark {
      height: 21px;
      width: 21px;
    }

    .gp-checkbox-text {
      margin-left: 20px;
    }
  }

  &.size-small {
    .checkmark {
      height: 18px;
      width: 18px;
      font-size: 9px;
    }

    .gp-checkbox-text {
      margin-left: 18px;
    }
  }

  .checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    display: none;
  }

  .checkmark {
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
    height: 21px;
    width: 21px;
    border-radius: 50%;
    background-color: $light1;
    border: 2px solid $textLightModeDisabled;
    font-weight: 700;
    font-size: 11px;
    color: $light1;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 52%;
      height: 52%;
    }
  }

  .gp-checkbox-text {
    font-family: inherit;
  }

  &.gp-checkbox-wrap:hover .checkmark {
    background-color: $light1;
    border-color: $textLightModeLow;
  }

  &.gp-checkbox-wrap .checkmark.checked {
    border-color: $mono3;
  }

  .other-input {
    border: 1px solid #3C67FF;
  }
}
</style>
